// 150MB - Default limit form Media Conversations: https://www.twilio.com/docs/conversations/conversations-limits#media-limits
export const DEFAULT_MAX_FILE_SIZE = 150;

// Non specific restrictyion on file types, just for business agreement
export const acceptedFileTypes = [
  "image/*",
  ".txt",
  ".rtf",
  ".csv",
  ".json",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
  ".xls",
  ".xlsx",
  ".pdf",
];
